import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5 flex-column flex-md-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-center align-items-md-start flex-column mb-5 mb-md-0 mt-5 mt-md-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Applicants"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "List of applicants")
], -1)
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "card mb-5 mb-xl-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5 flex-column flex-md-row" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-center align-items-md-start flex-column mb-5 mb-md-0 mt-5 mt-md-0" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Recently Promoted"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "List of all applicants who have been promoted in the last 30 days")
  ])
], -1)
const _hoisted_7 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ApplicantsDataTable = _resolveComponent("ApplicantsDataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_SearchField, {
          placeholder: 'Search applicant',
          onChangeSearch: _ctx.handleSearch
        }, null, 8, ["onChangeSearch"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_ctx.applicants.length == 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: 'OOPS... Unfortunately no applicants were found.'
              }, null, 8, ["description"]))
            : (_openBlock(), _createBlock(_component_ApplicantsDataTable, {
                key: 2,
                "show-applied-date": true,
                onApproveApplicant: _ctx.handleApprove,
                applicants: _ctx.applicants
              }, null, 8, ["onApproveApplicant", "applicants"])),
        _createVNode(_component_Pagination, {
          currentPage: _ctx.pagination.currentPage,
          totalPages: _ctx.pagination.totalPages,
          onChangeCurrentPage: _ctx.handlePageChange
        }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_ctx.recentlyPromoted.length == 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: 'OOPS... Unfortunately no recently promoted applicants were found.'
              }, null, 8, ["description"]))
            : (_openBlock(), _createBlock(_component_ApplicantsDataTable, {
                key: 2,
                onApproveApplicant: _ctx.handleApprove,
                actionButtons: false,
                "show-applied-date": false,
                applicants: _ctx.recentlyPromoted
              }, null, 8, ["onApproveApplicant", "applicants"])),
        _createVNode(_component_Pagination, {
          currentPage: _ctx.pagination.currentPage,
          totalPages: _ctx.pagination.totalPages,
          onChangeCurrentPage: _ctx.handlePageChange
        }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
      ])
    ])
  ]))
}